export default __webpack_public_path__ + "static/media/logobg.884cdf01.svg";